// src/components/Store/secretarySlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';
import BaseUrl from '../../BaseUrl';

// Fixed URLs - corrected the typo in API_URL
const API_URL = BaseUrl.authurl
const invoiceurl = BaseUrl.invoiceurl
const BASE_URL = BaseUrl.hmsurl

// Helper function to get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('accessToken');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
};

// Async thunks
export const registerPatient = createAsyncThunk(
  'secretary/registerPatient',
  async (patientData, { rejectWithValue }) => {
    try {
      
      console.log(patientData)
      const response = await axios.post(`${API_URL}Auth/AddPatient`, patientData, {
        headers: {
          'accept': '*/*',
          'Content-Type': 'application/json',
        }
      });
      
      
      
      if (response.data && response.data.Success) {
        toast.success('Patient registered successfully!');
        return response.data;
      } else {
        const errorMsg = response.data?.Message || 'Registration failed';
        toast.error(errorMsg);
        return rejectWithValue({ message: errorMsg });
      }
    } catch (error) {
      console.error('Registration error details:', {
        message: error.message,
        code: error.code,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        config: {
          url: error.config?.url,
          method: error.config?.method,
          baseURL: error.config?.baseURL
        }
      });
      
      const errorMessage = error.response?.data?.Message || 
                          error.response?.data?.message || 
                          error.message || 
                          'Registration failed';
      
      toast.error(errorMessage);
      
      return rejectWithValue({
        message: errorMessage,
        status: error.response?.status,
        data: error.response?.data
      });
    }
  }
);

export const searchPatients = createAsyncThunk(
  'secretary/searchPatients',
  async (searchTerm, { rejectWithValue }) => {
    try {
      
      
      const response = await axios.get(
        `${API_URL}Auth/GetPatients?id=${encodeURIComponent(searchTerm)}`,
        {
          headers: {
            'accept': '*/*',
          }
        }
      );
      
      
      return response.data;
    } catch (error) {
      console.error('Search error:', error);
      const message = error.response?.data?.message || 
                     error.response?.data?.Message || 
                     error.message || 
                     'Failed to search patients';
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchDoctors = createAsyncThunk(
  'secretary/fetchDoctors',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${API_URL}Doctors`,
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchBeds = createAsyncThunk(
  'secretary/fetchBeds',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}Beds`,
        { headers: { 'accept': 'text/plain' } }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchFloors = createAsyncThunk(
  'secretary/fetchFloors',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}Floors`,
        { headers: { 'accept': 'text/plain' } }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchRooms = createAsyncThunk(
  'secretary/fetchRooms',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}Rooms`,
        { headers: { 'accept': 'text/plain' } }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchPatients = createAsyncThunk(
  'secretary/fetchPatients',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${API_URL}Patients`,
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchInvoices = createAsyncThunk(
  'secretary/fetchInvoices',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${invoiceurl}Invoices`,
        { headers: getAuthHeaders() }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const searchInvoicesByNameOrPhone = createAsyncThunk(
  'secretary/searchInvoicesByNameOrPhone',
  async (searchValue, { rejectWithValue }) => {
    try {
      
      const response = await axios.get(
        `${invoiceurl}Invoices/GetInvoiceByNameOrPhone?Value=${encodeURIComponent(searchValue)}`,
        { headers: { 'accept': '*/*' } }
      );
      
      return response.data;
    } catch (error) {
      console.error('Invoice search error:', error);
      const message = error.response?.data?.message || 
                     error.response?.data?.Message || 
                     error.message || 
                     'Failed to search invoices';
      toast.error(message);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createInvoice = createAsyncThunk(
  'secretary/createInvoice',
  async (invoiceData, { rejectWithValue }) => {
    try {
      
      const response = await axios.post(
        `${invoiceurl}Invoices/GenerateInvoice`,
        invoiceData,
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json',
          }
        }
      );
      
      
      if (response.data && response.data.Success) {
        toast.success('Invoice created successfully!');
        return response.data;
      } else {
        const errorMsg = response.data?.Message || 'Failed to create invoice';
        toast.error(errorMsg);
        return rejectWithValue({ message: errorMsg });
      }
    } catch (error) {
      console.error('Invoice creation error:', error);
      const message = error.response?.data?.message || 
                     error.response?.data?.Message || 
                     error.message || 
                     'Failed to create invoice';
      toast.error(message);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const collectPayment = createAsyncThunk(
  'secretary/collectPayment',
  async (paymentData, { rejectWithValue }) => {
    try {
      
      const response = await axios.patch(
        `${invoiceurl}Invoices/CollectPayment`,
        paymentData,
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json',
          }
        }
      );
      
      
      if (response.data && response.data.Success) {
        toast.success('Payment collected successfully!');
        return response.data;
      } else {
        const errorMsg = response.data?.Message || 'Failed to collect payment';
        toast.error(errorMsg);
        return rejectWithValue({ message: errorMsg });
      }
    } catch (error) {
      console.error('Payment collection error:', error);
      const message = error.response?.data?.message || 
                     error.response?.data?.Message || 
                     error.message || 
                     'Failed to collect payment';
      toast.error(message);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const uploadPatientDocument = createAsyncThunk(
  'secretary/uploadPatientDocument',
  async ({ patientId, file, documentType }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('documentType', documentType);
      formData.append('patientId', patientId);

      const response = await axios.post(
        `${API_URL}Patients/${patientId}/documents`,
        formData,
        { 
          headers: {
            ...getAuthHeaders(),
            'Content-Type': 'multipart/form-data',
          }
        }
      );
      
      if (response.data && response.data.Success) {
        toast.success('Document uploaded successfully!');
        return response.data;
      } else {
        const errorMsg = response.data?.Message || 'Failed to upload document';
        toast.error(errorMsg);
        return rejectWithValue({ message: errorMsg });
      }
    } catch (error) {
      const message = error.response?.data?.message || 
                     error.response?.data?.Message || 
                     'Failed to upload document';
      toast.error(message);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  patients: [],
  doctors: [],
  beds: [],
  floors: [],
  rooms: [],
  invoices: [],
  invoiceSearchResults: [],
  loading: false,
  error: null,
  selectedPatient: null,
  selectedFloor: null,
  selectedRoom: null,
  stats: {
    totalPatients: 0,
    pendingInvoices: 0,
    availableBeds: 0,
    verifiedPatients: 0,
    totalBeds: 0,
    occupiedBeds: 0,
  },
};

const secretarySlice = createSlice({
  name: 'secretary',
  initialState,
  reducers: {
    setSelectedPatient: (state, action) => {
      state.selectedPatient = action.payload;
    },
    setSelectedFloor: (state, action) => {
      state.selectedFloor = action.payload;
      state.selectedRoom = null;
    },
    setSelectedRoom: (state, action) => {
      state.selectedRoom = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    updateStats: (state) => {
      const availableBeds = state.beds.filter(bed => bed.isAvailable).length;
      const pendingInvoices = state.invoices.filter(inv => 
        inv.status === 'Pending' || inv.status === 'pending' || 
        inv.invoiceStatus === 'Unpaid' || inv.invoiceStatus === 'unpaid'
      ).length;
      
      state.stats = {
        totalPatients: state.patients.length,
        pendingInvoices: pendingInvoices,
        availableBeds: availableBeds,
        verifiedPatients: state.patients.filter(p => p.verified).length,
        totalBeds: state.beds.length,
        occupiedBeds: state.beds.length - availableBeds,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      // Register Patient
      .addCase(registerPatient.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(registerPatient.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload && action.payload.Id) {
          const newPatient = {
            id: action.payload.Id,
            ...action.payload
          };
          state.patients.push(newPatient);
        }
        secretarySlice.caseReducers.updateStats(state);
      })
      .addCase(registerPatient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Search Patients
      .addCase(searchPatients.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchPatients.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(searchPatients.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch Doctors
      .addCase(fetchDoctors.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDoctors.fulfilled, (state, action) => {
        state.loading = false;
        state.doctors = action.payload || [];
      })
      .addCase(fetchDoctors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch Beds
      .addCase(fetchBeds.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBeds.fulfilled, (state, action) => {
        state.loading = false;
        state.beds = action.payload || [];
        secretarySlice.caseReducers.updateStats(state);
      })
      .addCase(fetchBeds.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch Floors
      .addCase(fetchFloors.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFloors.fulfilled, (state, action) => {
        state.loading = false;
        state.floors = action.payload || [];
      })
      .addCase(fetchFloors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch Rooms
      .addCase(fetchRooms.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRooms.fulfilled, (state, action) => {
        state.loading = false;
        state.rooms = action.payload || [];
      })
      .addCase(fetchRooms.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch Patients
      .addCase(fetchPatients.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPatients.fulfilled, (state, action) => {
        state.loading = false;
        state.patients = action.payload || [];
        secretarySlice.caseReducers.updateStats(state);
      })
      .addCase(fetchPatients.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch Invoices
      .addCase(fetchInvoices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInvoices.fulfilled, (state, action) => {
        state.loading = false;
        state.invoices = action.payload || [];
        secretarySlice.caseReducers.updateStats(state);
      })
      .addCase(fetchInvoices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Search Invoices By Name Or Phone
      .addCase(searchInvoicesByNameOrPhone.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchInvoicesByNameOrPhone.fulfilled, (state, action) => {
        state.loading = false;
        state.invoiceSearchResults = action.payload || [];
      })
      .addCase(searchInvoicesByNameOrPhone.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.invoiceSearchResults = [];
      })

      // Create Invoice
      .addCase(createInvoice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createInvoice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload && action.payload.Id) {
          const newInvoice = {
            id: action.payload.Id,
            ...action.payload
          };
          state.invoices.push(newInvoice);
        }
        secretarySlice.caseReducers.updateStats(state);
      })
      .addCase(createInvoice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Collect Payment
      .addCase(collectPayment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(collectPayment.fulfilled, (state, action) => {
        state.loading = false;
        if (action.meta.arg && action.meta.arg.InvoiceNumber) {
          const invoiceIndex = state.invoices.findIndex(
            inv => inv.id === action.meta.arg.InvoiceNumber || inv.Id === action.meta.arg.InvoiceNumber
          );
          if (invoiceIndex !== -1) {
            state.invoices[invoiceIndex] = {
              ...state.invoices[invoiceIndex],
              invoiceStatus: 'Paid',
              status: 'Paid',
              paymentDate: action.meta.arg.CollectionDate,
              paymentMode: action.meta.arg.PaymentMode
            };
          }
        }
        secretarySlice.caseReducers.updateStats(state);
      })
      .addCase(collectPayment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Upload Patient Document
      .addCase(uploadPatientDocument.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadPatientDocument.fulfilled, (state, action) => {
        state.loading = false;
        const patient = state.patients.find(p => p.id === action.meta.arg.patientId || p.Id === action.meta.arg.patientId);
        if (patient) {
          patient.documents = patient.documents || [];
          patient.documents.push(action.payload);
        }
      })
      .addCase(uploadPatientDocument.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Selectors
export const selectFloorsWithDetails = (state) => {
  const { floors, rooms, beds } = state.secretary;
  
  return floors.map(floor => ({
    ...floor,
    rooms: rooms.filter(room => room.floorId === floor.floorId).map(room => ({
      ...room,
      beds: beds.filter(bed => bed.roomId === room.roomId),
      totalBeds: beds.filter(bed => bed.roomId === room.roomId).length,
      availableBeds: beds.filter(bed => bed.roomId === room.roomId && bed.isAvailable).length
    })),
    totalBeds: beds.filter(bed => 
      rooms.filter(room => room.floorId === floor.floorId)
           .some(room => room.roomId === bed.roomId)
    ).length,
    availableBeds: beds.filter(bed => 
      rooms.filter(room => room.floorId === floor.floorId)
           .some(room => room.roomId === bed.roomId) && bed.isAvailable
    ).length
  }));
};

export const selectRoomsByFloor = (state, floorId) => {
  const { rooms, beds } = state.secretary;
  return rooms
    .filter(room => room.floorId === floorId)
    .map(room => ({
      ...room,
      beds: beds.filter(bed => bed.roomId === room.roomId),
      totalBeds: beds.filter(bed => bed.roomId === room.roomId).length,
      availableBeds: beds.filter(bed => bed.roomId === room.roomId && bed.isAvailable).length
    }));
};

export const selectBedsByRoom = (state, roomId) => {
  const { beds } = state.secretary;
  return beds.filter(bed => bed.roomId === roomId);
};

export const { setSelectedPatient, setSelectedFloor, setSelectedRoom, clearError } = secretarySlice.actions;
export default secretarySlice.reducer;